import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-tutorial-change-group',
  templateUrl: './tutorial-change-group.component.html',
  styleUrls: ['./tutorial-change-group.component.css']
})
export class TutorialChangeGroupComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
